<template>
  <ul class="menuList">
    <li @click.stop="showSequenceSection">
      <span class="svgIcon" id="e_sequence"></span>
      <span class="text">Add to Sequence</span>
    </li>
    <li @click.stop="exportContact">
      <span class="svgIcon" id="e_contacts"></span>
      <span class="text">Export to Salesgear</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MainMenu',
  props: ['contactData'],
  data: function() {
    return {
      loading: false,
      listName: this.$store.state.linkedin.list.selectedList
    }
  },
  methods: {
    showSequenceSection() {
      this.$emit('setMainMenu', false)
    },
    async exportContact() {
      this.$emit('exportContact')
    }
  }
}
</script>
